export enum ItemType {
    Event = 'event',
    EventSeries = 'eventSeries',
    Artist = 'artist',
    City = 'city',
    Campaign = 'campaign',
    Miscellaneous = 'misc',
    Venue = 'venue',
}
